// 統一使用由 website_supabase_backend 建立的官方 Supabase 客戶端
export { supabase } from '@/integrations/supabase/client';
import { supabase } from '@/integrations/supabase/client';

export const isSupabaseConfigured = true;

// ── 訂閱者型別 ─────────────────────────────────────────
export interface Subscriber {
  id: string;
  email: string;
  name: string | null;
  subscribed_at: string;
  is_active: boolean;
}

// ── 新增訂閱者 ─────────────────────────────────────────
export async function addSubscriber(email: string, name?: string): Promise<Subscriber> {
  const { data, error } = await supabase
    .from('subscribers')
    .upsert(
      { email: email.toLowerCase().trim(), name: name ?? null, is_active: true },
      { onConflict: 'email', ignoreDuplicates: false }
    )
    .select()
    .single();
  if (error) throw error;
  return data as Subscriber;
}

// ── 取得所有有效訂閱者 ─────────────────────────────────
export async function getSubscribers(): Promise<Subscriber[]> {
  const { data, error } = await supabase
    .from('subscribers')
    .select('*')
    .eq('is_active', true)
    .order('subscribed_at', { ascending: false });
  if (error) throw error;
  return data as Subscriber[];
}

// ── 取消訂閱（停用）──────────────────────────────────
export async function unsubscribe(id: string): Promise<void> {
  const { error } = await supabase
    .from('subscribers')
    .update({ is_active: false })
    .eq('id', id);
  if (error) throw error;
}
